
/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { deleteSurvey } from '../../../actions/survey';
import { SubmitButton } from '../../button/SubmitButton';
import { useDispatch } from 'react-redux';
import Loader from '../../loader'
import { BasicAlert } from '../../alert/BasicAlert';
import { getAnalytics } from '../../../services/analytics/AnalyticsService';
import { AnalyticsEvents } from '../../../services/analytics/AnalyticsEvents';

export interface ReportDeleteModalProps {
  handleClose: () => void,
  survey: any,
  display: boolean
}

const ReportDeleteModal = ({ survey, display, handleClose }: ReportDeleteModalProps) => {
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState('')
  const dispatch = useDispatch();
  if (!display) {
    return null
  }

  const handlClick = async () => {
    try {
      setSaving(true)
      await dispatch(deleteSurvey(survey._id));
      const analytics = getAnalytics();
      await analytics.track(AnalyticsEvents.SurveyDeleted, {
        initiativeId: survey.initiativeId,
        surveyId: survey._id
      });
      setSaving(false)
      handleClose()
      setMessage('')

    } catch (e) {
      setSaving(false)
      setMessage(e.message)
    }
  }

  return (
    <Modal isOpen={display} toggle={handleClose} backdrop='static'>
      <ModalHeader toggle={handleClose}>Delete Report Survey </ModalHeader>
      <ModalBody>
        {saving && <Loader />}
        <BasicAlert type={'danger'}>{message}</BasicAlert>
        Are you sure you would like to delete this report survey?
      </ModalBody>
      <ModalFooter>
        <Button color='link-secondary' className='mr-2' onClick={handleClose}>Cancel</Button>
        <SubmitButton color='danger' onClick={handlClick} className='text-right'><span>Delete</span></SubmitButton>
      </ModalFooter>
    </Modal>
  );
};

export default ReportDeleteModal
